<div class="audioBtnWrapper">
  <div class="d-inline">
    @if (this.getState() === 'idle') {
    <button
      class="btn  playT2S"
      aria-label="Vorlesen starten"
      i18n-aria-label="@@audio-btn-play"
      (click)="this.playAudio()"
      [disabled]="this.isDisabled()"
    >
      <i
        class="ri-play-circle-line ri-lg"
        aria-hidden="true"
      ></i>
    </button>
    }
    @if (this.getState() === 'load') {
    <button
      class='btn loadT2S'
      aria-label="Wird geladen"
      i18n-aria-label="@@audio-btn-loading"
    >
      <i
        class='ri-loader-4-line ri-lg'
        aria-hidden="true"
      ></i>
    </button>
    }
    @if (this.getState() === 'play') {
    <button
      class='btn  playT2S'
      aria-label="Vorlesen stoppen"
      i18n-aria-label="@@audio-btn-stop"
      (click)='this.stopAudio()'
      [disabled]="this.isDisabled()"
    >
      <i
        class='ri-stop-circle-line ri-lg'
        aria-hidden="true"
      ></i>
    </button>
    }
  </div>
</div>